import * as React from 'react';
import Link from 'components/Link';
import classNames from 'styles/utils/classNames';

interface Props {
  href: string;
  children: React.ReactNode;
  isActive?: boolean;
  isInvert?: boolean;
  onNavigate: (href: string) => void;
}

export default function NavLink({ href, children, isActive, isInvert, onNavigate }: Props) {
  const activeClass = isInvert
    ? 'typography-product-subheading text-color-text-lightmode-invert dark:text-color-text-darkmode-invert'
    : 'typography-product-subheading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary';

  const inactiveClass = isInvert
    ? 'typography-product-body text-color-text-darkmode-secondary dark:text-color-text-lightmode-secondary'
    : 'typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary';

  return (
    <Link
      href={href}
      onClick={(e) => {
        e.preventDefault();
        onNavigate(href);
      }}
      className={classNames(
        'typography-product-body hover:typography-product-subheading group relative flex w-[90px] flex-col items-center justify-center rounded-full px-ds-lg py-2 transition-colors',
        isActive ? activeClass : inactiveClass,
      )}
    >
      {children}
    </Link>
  );
}
